import { TableBody, TableCell, TableRow } from "@windmill/react-ui";
import PartialPaymentDrawer from "components/drawer/PartialPaymentDrawer";
import MainDrawer from "components/drawer/MainDrawer";
import DeleteModal from "components/modal/DeleteModal";
// import ViewModal from "components/modal/ViewModal";
import ViewModal from "components/modal/ViewPartialPayment";
import EditDeleteButton from "components/table/EditDeleteButton";

import useToggleDrawer from "hooks/useToggleDrawer";
import React from "react";

import RemarkModal from "components/modal/RemarkModal";

// internal imports

const PartialPaymentTable = ({
  partialpayment,
  perpage,
  currentPage,
  tab,
  hideEdit,
}) => {
  const { title, serviceId, serviceBlock, handleModalOpen, handleUpdate } =
    useToggleDrawer();
  // const [isRemarkModalOpen, setIsRemarkModalOpen] = useState(false);
  // const [selectedPartialPayment, setSelectedPartialPayment] = useState(null);

  return (
    <>
      <RemarkModal
        id_data={serviceId}
        block_data={serviceBlock}
        title_data={title}
      ></RemarkModal>
      <DeleteModal id={serviceId} title={title} />
      <ViewModal id={serviceId} title={title} data={partialpayment} />

      <MainDrawer>
        <PartialPaymentDrawer id={serviceId} tab={tab} />
      </MainDrawer>

      <TableBody>
        {partialpayment?.slice(0, perpage).map((data, index) => (
          <TableRow key={data.id}>
            <TableCell className="text-center text-sm">
              {(currentPage - 1) * perpage + index + 1}
            </TableCell>

            <TableCell className="text-center text-sm">
              {data.more_than_24}
            </TableCell>

            <TableCell className="text-center text-sm">
              {data.less_than_24}
            </TableCell>

            <TableCell className="text-center">
              <EditDeleteButton
                title={data.name}
                id={data.id}
                handleUpdate={handleUpdate}
                handleModalOpen={handleModalOpen}
                hideDelete={true}
                hideEdit={hideEdit}
              />
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </>
  );
};

export default PartialPaymentTable;
